import { ArrowBackIosNewSharp, MoreVert, Print, PrintDisabled } from '@mui/icons-material';
import { Paper, Stack, Typography, Grid, Button, Divider, Table, TableHead, TableBody, TableRow, TableCell, Tabs, Tab, Box, Chip, useMediaQuery } from '@mui/material';
import { format, parse } from 'date-fns';
import React, {useState} from 'react';
import {gridEventi, orderDetail, usersOrders} from '../../../../api/testataordine'
import DefaultLoadingComponent from '../../../form/DefaultLoadingComponent';
import { NoPreviousData } from '../../../preventivo/Preventivo';
import TabelleEntries from '../../../TabelleEntries';
import useSWRImmutable from 'swr/immutable';
import { tabsDettaglio } from '../utils'; 
import __t from '../../../../lib/traduzioni';
import useBSSLogger from "../../../../hooks/useBSSLogger";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@emotion/react';
import DefaultErrorComponent from '../../../form/DefaultErrorComponent';

const {logger} = useBSSLogger();



const DettaglioOrdine = ({codiceOrdine, stati, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica}) => {

    let urlOrdini = new URL(location.href);
    let searchObj = urlOrdini.searchParams;
    const tab = Number(searchObj.get("tab")) ?? 0
    searchObj.delete("ordine");
    searchObj.delete("tab");
    urlOrdini.search = searchObj;
    const [statoTab, setStatoTab] = useState(tab)
    const theme = useTheme();
    const isPhone = useMediaQuery(theme.breakpoints.down("md"))

    const retrieveOrdine = async () => {

        await gridEventi();

        const {results} = await usersOrders({
            pageSize: 1,
            take: 1,
            skip: 0, 
            page: 1,
            filter: {
                logic: "and",
                filters: [
                    {field: "codiceordine", operator: "eq", value: codiceOrdine}
                ]
            }
        });
                
        const tesord = results?.[0] ?? null;

        let ordine = null;
        
        if(tesord !== null){
            ordine = await orderDetail(tesord.id);
        }
        

        return {
            ordine
        }
    }

    const {data, error, mutate: aggiornaOrdini} = useSWRImmutable(`/api/ordine?${codiceOrdine}`, retrieveOrdine, {
        onErrorRetry: (error, key, config, revalidate) => {
            return             
        }
    })

    
    
    if(!error && !data){
        return (<DefaultLoadingComponent />) 
    } 

    if(error){
        logger.debug("errore", error)
        return <DefaultErrorComponent {...{error}} />
    }   

    if(data.ordine === null){
        return (
            <>
                <NoPreviousData message={__t("nessunordine")} />
            </>
        )
    }

    const ordine = {
        ...data.ordine.testataordine,
        datiint: data.ordine.datiint,
        storicoeventi: data.ordine.storicoeventi,
        righe: data.ordine.listaRighe,
        servizi: data.ordine.listaAddizionali,
        documenti: data.ordine.listaInformazioniDocumentiCollegati,
        pagamenti: data.ordine.listapagamenti
    }
    let stileStato = {};
    
    if(ordine !== null){
        stileStato = {
            color: ordine.statoordine.coloretesto,
            backgroundColor: ordine.statoordine.colorestato,
            fontWeight: "bold"
        }
    }

    //@TODO l'icona della stampante deve stampare il segnacollo al click
    const datiTestata = {
        [`#${ordine.codiceordine}`]: {
            [__t("printrequired")]: <>
                {ordine.printerrequired ? <Print color="warning" /> : <PrintDisabled color="success" />}
            </>,
            [__t("dataordine")]:  format(parse(ordine.dataordine, 'yyyy-MM-dd HH:mm:ss.SSS', new Date()), 'dd/MM/yyyy'),
            [__t("dataritiroprevista")]: format(parse(ordine.dataritiro, 'yyyy-MM-dd HH:mm:ss.SSS', new Date()), 'dd/MM/yyyy'),
            [__t("totale")]: <Typography variant={"h6"}>€ {ordine.totaleivato.toFixed(2)}</Typography>
        }
    }

    const TabComp = tabsDettaglio?.[statoTab ?? 0]?.comp ?? null;

    return (
        <Stack>

            <Paper sx={{
                "& ::selection": stileStato, 
                borderRadius: 2, 
                border: `thin solid ${stileStato.backgroundColor}`,
                mt: 2, 
                p: 2
            }}>

                <Typography variant="body1">
                    <Grid container spacing={1} columns={12}>     
                        <Grid item xs={6}>
                            <Button variant={"contained"} href={urlOrdini}>
                                <ArrowBackIosNewSharp /> {__t("storicoordini")}
                            </Button>
                        </Grid>                           
                        <Grid item xs={6} sx={{textAlign: "right"}}>
                            <Button sx={{minWidth: 0, color: stileStato.backgroundColor}} onClick={e => setStatoMenu({anchorEl: e.currentTarget, open: true, ordine, avoidTabs: true})}>
                                <MoreVert />
                            </Button>
                        </Grid> 
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>

                        {/* <Grid item xs={6}>
                            #{ordine.codiceordine}
                        </Grid>                                                 
                        
                        <Grid item xs={6} sx={{fontWeight: "bold", textAlign: "right"}}>
                            <Chip sx={{...stileStato}} label={ordine.statoordine.codicestato} />     
                        </Grid>   */}

                        <Grid item xs={12}>
                            
                                <TabelleEntries 
                                    tabelle={datiTestata} 
                                    wrapped
                                    
                                    customRowHeader={({defaultStyles}) => {

                                        return (
                                            <TableRow sx={defaultStyles.rowHeaderStyle}>
                                                {!isPhone ? (
                                                    <>
                                                        <TableCell>
                                                            <Typography variant={"h6"} sx={{textAlign: "left"}}>
                                                                #{ordine.codiceordine}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align={"right"}>
                                                            <Chip sx={{...stileStato}} label={ordine.statoordine.codicestato} />   
                                                        </TableCell>
                                                    </>
                                                ): (
                                                    <TableCell colSpan={2}>
                                                        <Stack>
                                                            <Typography variant={"h6"} sx={{textAlign: "left"}}>
                                                                #{ordine.codiceordine}
                                                            </Typography>
                                                            <Chip sx={{...stileStato}} label={ordine.statoordine.codicestato} />   
                                                        </Stack>
                                                        
                                                    </TableCell>                                                   
                                                )}
                                                
                                            </TableRow>                                    
                                        )
                                    }}                                
                                />
                        </Grid>                        

                        <Grid item xs={12}>
                            <Tabs 
                                sx={{
                                    "& .MuiTab-root": {
                                        alignItems: "flex-start"
                                    }
                                }}
                                variant="scrollable" allowScrollButtonsMobile={true} value={statoTab} onChange={(e, newValue) => setStatoTab(newValue)}>  
                                {tabsDettaglio
                                    .map((tab, indiceLabel) => {

                                    return (
                                        <Tab 
                                            key={indiceLabel} label={tab.label} 
                                        />                                            
                                    )
                                })}
                            </Tabs>
                            <Box pt={1}>
                                {(TabComp !== null) && (
                                    <TabComp ordine={ordine} tabObj={tabsDettaglio[statoTab]} />
                                )}
                                
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            {/* <ReactJson src={ordine} theme={"harmonic"} /> */}
                        </Grid>
                    </Grid>
                </Typography>
                
            </Paper>

        </Stack>
    )
}

export default DettaglioOrdine;